@if (contact.isRegisterOnPortal) {
<div class="checkbox">
    <por-base-checkbox [isChecked]="checked" (checkboxChange)="onCheckboxChange($event)" [showLabel]="false"></por-base-checkbox>
</div>
}
